export const ExportHubReportSectionId = {
  Clients: 1,
  Income: 2,
} as const

export type ExportHubReportSectionId =
  (typeof ExportHubReportSectionId)[keyof typeof ExportHubReportSectionId]

export const ExportHubReportSection = {
  [ExportHubReportSectionId.Clients]: 'Clients',
  [ExportHubReportSectionId.Income]: 'Income',
} as const

export const ExportHubReportFormatId = {
  CSV: 1,
  PDF: 2,
} as const

export type ExportHubReportFormatId =
  (typeof ExportHubReportFormatId)[keyof typeof ExportHubReportFormatId]

export const ExportHubReportFormat = {
  [ExportHubReportFormatId.CSV]: 'CSV',
  [ExportHubReportFormatId.PDF]: 'PDF',
} as const

export const customRangeExportMode = 1
export const visibleDataExportMode = 2
type ReportExportMode = typeof customRangeExportMode | typeof visibleDataExportMode

export const ExportHubReportStatusId = {
  Processing: 1,
  Ready: 2,
  Failed: 3,
  Expired: 4,
} as const

export type ExportHubReportStatusId =
  (typeof ExportHubReportStatusId)[keyof typeof ExportHubReportStatusId]

export const ExportHubReportStatus = {
  [ExportHubReportStatusId.Processing]: 'Processing',
  [ExportHubReportStatusId.Ready]: 'Ready',
  [ExportHubReportStatusId.Failed]: 'Failed',
  [ExportHubReportStatusId.Expired]: 'Expired',
} as const

export const ExportHubSectionFilterOptions = Object.entries(ExportHubReportSection).map(
  ([id, name]) => ({ id: Number(id), name })
)

export interface ExportHubDto {
  id: string
  reportName: string
  section: ExportHubReportSectionId
  format: ExportHubReportFormatId
  status: ExportHubReportStatusId
  statusChangedAt: string
  expiresAt: string
  downloadUrl: string
  canDownload: boolean
  canRetry: boolean
  acknowledgedAt: string | null
  createdDate: string
  updatedDate: string
}

export interface ExportHubSearch {
  pageIndex?: number
  pageSize?: number

  ca_search_TextSearch?: string

  HasTradingAccounts?: boolean

  AccountType?: string[]
  Country?: string[]
  TickmillCompany?: string[]

  FxmVolumeFrom?: string[]
  FxmVolumeTo?: string[]

  OtherVolumeFrom?: string[]
  OtherVolumeTo?: string[]

  FxmAmountFrom?: string[]
  FxmAmountTo?: string[]

  OtherAmountFrom?: string[]
  OtherAmountTo?: string[]

  // table filters
  DateFrom?: string
  DateTo?: string

  // Export Hub API
  TradePeriodFrom?: string
  TradePeriodTo?: string

  RegistrationDateFrom?: string[]
  RegistrationDateTo?: string[]

  [key: string]: string | number | boolean | string[] | number[] | null | undefined
}

export interface ExportHubPayload {
  section: ExportHubReportSectionId
  format: ExportHubReportFormatId
  mode: ReportExportMode
  filters: {
    dateFrom?: string | null
    dateTo?: string | null
    search?: ExportHubSearch
  }
}
